const translations = {
    'prompt.houseFoodTarget': 'Set house food target (hours):',
    'prompt.houseHeatTarget': 'Set house heat target (hours):',
    'prompt.blacksmithToolsTarget': 'Set blacksmith tool target (%s):',
    'prompt.blacksmithWeaponsTarget': 'Set blacksmith weapon target (%s):',
    'prompt.productionInputCap': 'Set input cap (%s):',
    'prompt.productionOutputCap': 'Set output cap (%s):',
};

export default translations;
